<!-- 工作台 待办 卡片 -->
<template>
  <div class="workbench_card_todo_style" v-loading="todoLoading">
    <div class="workbench_card_todo_left_style">
      <div class="workbench_left_carousel_style">
        <el-carousel indicator-position="none" :autoplay="false" v-if="getToDototal>0">
          <el-carousel-item v-for="(item,i) in todoSize" :key="i">
            <div class="carousel_page_style">
              <div class="carousel_child_style" v-for="(element,index) in 9" :key="i">
                <div class="carousel_child_text_style" v-if="(i * 9 + index) < getToDototal" @click="navigateTo(i,index)">
                  <div><span>{{ viewTodo(i,index).name }}</span><span style="text-shadow: none;padding-left: 10px;">{{ viewTodo(i,index).statusName }}</span><span style="color:#165DFF;font-size:16px;padding-left: 10px;">{{ viewTodo(i,index).number }}{{ h_i18n('cc1bacb5117aa3f27e5e430cd28dbaed') }}</span></div>
                  <!-- <img src="@/assets/images/todo.png"/> -->
                  <!-- <span style="color: #fff;">{{viewTodo(i,index)}}</span> -->
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="noTodo_style" v-else>
          <img src="../../assets/img/no-data.png" width="96" height="96" />
          <div class="nodata-style">{{ h_i18n('44406eaf8750d430f883a9981c1fbcb2') }}</div>
        </div>
      </div>

    </div>
    <!-- <div class="workbench_card_todo_mid_style"></div>
    <div class="workbench_card_todo_right_style">
      <div id="theCharts" style="min-width:250px;height:100%;width: 100%;"></div>
    </div> -->
  </div>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, defineComponent, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed, toRefs, watch } from 'vue';
  import * as echarts from 'echarts'
  import { useRoute } from "vue-router"
import { useStore } from 'vuex';
  export default defineComponent({
    name: "todo_card",
    props:{
      queryData:{
        type: Object,
        default() {
          return {}
        }
      },
    },
    setup(props,{emit}) {
      const route = useRoute();
      const store = useStore();
      const { proxy } = getCurrentInstance();
      const data = reactive({
        theTodoList:[],
        todoSize:0, // 每六个待办一页，计算页数
        getToDototal:0, // 每一个待办类别的入口数 (keylist)的长度
        theTodoName:h_i18n('68acd810d20fb295ff2cebdbceb5cbfe'), // 当前tab名
        todoLoading:false,
        getData:[], // 待办接口获取数据
        toDoArray:[], // 当前显示的待办类别所有不为零的待办list
        treeData:[], // sqm总菜单
        dataList:[], // sqm总菜单一维
        publicParams:'' , // 基本参数
      });
      const todoObj = ref({
        newProductQualityTodoType:computed(()=>({ // 新品质量
          // 环保承诺书 未提交
          environmentSubmit:{resourceCode:'mkhl_yhwz_hbcns',resourceName: h_i18n('9dff884c419bc5aeaf71071d38fee690'),name:h_i18n('9dff884c419bc5aeaf71071d38fee690'),statusName:h_i18n('c3ef66a0cea6beb97c22dd26d4dd1728'),url:'',number:0},
          // 符合性声明 待提交
          conformityDeclarationsSubmit :{resourceCode:'mkhl_yhwzNew_fhxsm_new',resourceName: h_i18n('3fe23c87907c4bdfcd5b54f4ddc66360'),name:h_i18n('3fe23c87907c4bdfcd5b54f4ddc66360'),statusName:h_i18n('a9c09d3297b708f0ff815a93ec5f4145'),url:'',number:0},
          // 符合性声明 待审核
          conformityDeclarationsAudit :{resourceCode:'mkhl_yhwzNew_fhxsm_new',resourceName: h_i18n('3fe23c87907c4bdfcd5b54f4ddc66360'),name:h_i18n('3fe23c87907c4bdfcd5b54f4ddc66360'),statusName:h_i18n('5cb424765cb101866f47ca115605ce3b'),url:'',number:0},
          // RoHS报告库 预警中
          rohsReport:{resourceCode:'mkhl_yhwzNew_bgk_warn',resourceName: h_i18n('cec6876260f9cb712539bd8a42f54769'),name:h_i18n('3e269bfd5b2d084877f3cf2566229e07'),statusName:h_i18n('c10f502eae7a1921c8be2cbdf21caec2'),url:'',number:0},
          // RoHS宣告表 暂存
          rohsStagingCount:{resourceCode:'mkhl_yhwzNew_xgb_xin',resourceName: h_i18n('c8466e16f14442976eeb35b0fddba6b9'),name:h_i18n('3d2b8f26985da529d76b6d898ae3b6fe'),statusName:h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa'),url:'',number:0},
          // RoHS宣告表 质量部长驳回
          rohsBackCount:{resourceCode:'mkhl_yhwzNew_xgb_xin',resourceName: h_i18n('c8466e16f14442976eeb35b0fddba6b9'),name:h_i18n('3d2b8f26985da529d76b6d898ae3b6fe'),statusName:h_i18n('397b239eeb88a8796b1f8bbf58de351e'),url:'',number:0},
          // RoHS宣告表 海尔校核打回
          rohsRejectCount:{resourceCode:'mkhl_yhwzNew_xgb_xin',resourceName: h_i18n('c8466e16f14442976eeb35b0fddba6b9'),name:h_i18n('3d2b8f26985da529d76b6d898ae3b6fe'),statusName:h_i18n('1528b37e0e4ccb55ed708b9f1fbf1dbd'),url:'',number:0},
          // RoHS宣告表 待审核
          rohsWaitCout:{resourceCode:'mkhl_yhwzNew_xgb_xin',resourceName: h_i18n('c8466e16f14442976eeb35b0fddba6b9'),name:h_i18n('3d2b8f26985da529d76b6d898ae3b6fe'),statusName:h_i18n('5cb424765cb101866f47ca115605ce3b'),url:'',number:0},
          // 新品质量-APQP(旧) 待上传
          oldNewPtWaitApqpCount:{resourceCode:'mkhl_xpjyjh_old_apqp',resourceName: 'APQP',name:h_i18n('2b36030a302445461f14e736a9ff05b0')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('7027296030d6697a53257712a23bfc50'),url:'',number:0},
          // 新品质量-APQP(旧)  超期
          oldNewPtWaitApqpOverdueCount:{resourceCode:'mkhl_xpjyjh_old_apqp',resourceName: 'APQP',name:h_i18n('2b36030a302445461f14e736a9ff05b0')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('8556e8e115c933e48c8225ec4097f73f'),url:'',number:0},
          // 新品质量-APQP(旧) 驳回
          oldNewPtWaitApqpBackCount:{resourceCode:'mkhl_xpjyjh_old_apqp',resourceName: 'APQP',name:h_i18n('2b36030a302445461f14e736a9ff05b0')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
          // 新品质量-图纸(旧)  待上传
          oldNewPtWaitPictureCount:{resourceCode:'mkhl_xpjyjh_old_mbk',resourceName: h_i18n('533c77e44a32571f6884f699a84b0a56'),name:h_i18n('a66103b6a51221b9341e695ca1f7458e')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('7027296030d6697a53257712a23bfc50'),url:'',number:0},
          // 新品质量-图纸(旧) 驳回
          oldNewPtWaitPictureBackCount:{resourceCode:'mkhl_xpjyjh_old_mbk',resourceName: h_i18n('533c77e44a32571f6884f699a84b0a56'),name:h_i18n('a66103b6a51221b9341e695ca1f7458e')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
          // 新品质量-样检单(旧) 待送样
          oldNewPtWaitSendCount :{resourceCode:'mkhl_xpjyjh_old_xpyjd',resourceName: h_i18n('9bc00dfcaffa57bf6a9b324b02e8a3b3'),name:h_i18n('12258247648501647d50663328f0ab78')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('f1728af6ff0737b74b63d2238de7b5ca'),url:'',number:0},
          // 新品质量-样检单(旧) 送样超期
          oldNewPtWaitSendOverdueCount :{resourceCode:'mkhl_xpjyjh_old_xpyjd',resourceName: h_i18n('9bc00dfcaffa57bf6a9b324b02e8a3b3'),name:h_i18n('12258247648501647d50663328f0ab78')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('aba89743c71f48bf9af9347ac142caaf'),url:'',number:0},
          // 新品质量-样检单(旧) 送样驳回
          oldNewPtWaitSendBackCount :{resourceCode:'mkhl_xpjyjh_old_xpyjd',resourceName: h_i18n('9bc00dfcaffa57bf6a9b324b02e8a3b3'),name:h_i18n('12258247648501647d50663328f0ab78')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('c580a25a1afd0be7b6c80a6d310e0690'),url:'',number:0},
          // 新品质量-样检单 未送样
          newPtWaitSendCount :{resourceCode:'mkhl_xpjy_new',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('12258247648501647d50663328f0ab78'),statusName:h_i18n('2f86334d978ce238df05ef655a71309d'),url:'',number:0},
          // 新品质量-样检单 送样驳回
          newPtWaitSendBackCount :{resourceCode:'mkhl_xpjy_new',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('12258247648501647d50663328f0ab78'),statusName:h_i18n('c580a25a1afd0be7b6c80a6d310e0690'),url:'',number:0},
          // 新品质量-样检单 送样超期
          newPtWaitSendOverdueCount :{resourceCode:'mkhl_xpjy_new',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('12258247648501647d50663328f0ab78'),statusName:h_i18n('aba89743c71f48bf9af9347ac142caaf'),url:'',number:0},
          // 新品质量-PPAP 专用号未提交
          ppapOne :{resourceCode:'mkhl_ppap_old_jyjh',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('d20255f043fab2128f9a9588ce6d7ba6')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('e82c77cba4f49617ccf1e75ae16d17de'),url:'',number:0},
          // 新品质量-PPAP 专用号发布打回
          ppapThree:{resourceCode:'mkhl_ppap_old_jyjh',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('d20255f043fab2128f9a9588ce6d7ba6')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('6c1ccb254cad381bc1935040dca80305'),url:'',number:0},
          // 新品质量-PPAP(旧) 专用号暂存
          ppapTwo:{resourceCode:'mkhl_ppap_old_jyjh',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('d20255f043fab2128f9a9588ce6d7ba6')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('ecc3e9bb07ff5245f533df5b7d53580c'),url:'',number:0},
          // 新品质量-APQP(旧)  专用号未提交
          apqp :{resourceCode:'mkhl_xpjyjh_old_apqp',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('2b36030a302445461f14e736a9ff05b0')+"("+h_i18n('EC2E378A30AB94DE2C713BAFC04EAFA2')+")",statusName:h_i18n('e82c77cba4f49617ccf1e75ae16d17de'),url:'',number:0},
          // 新品质量-供方自检 待批准
          newPtWaitApprovalReportCount:{resourceCode:'mkhl_xpjy_new',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('5d4bdd5cbeed83478db6dfe177f62951'),statusName:h_i18n('29c43cf1a6de2d0affe76265cacb46bb'),url:'',number:0},
          // 新品质量-供方自检 待上传
          newPtWaitApqpCount:{resourceCode:'mkhl_xpjy_new',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('5d4bdd5cbeed83478db6dfe177f62951'),statusName:h_i18n('7027296030d6697a53257712a23bfc50'),url:'',number:0},
          // 新品质量-供方自检 驳回
          newPtWaitApqpBackCount:{resourceCode:'mkhl_xpjy_new',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('5d4bdd5cbeed83478db6dfe177f62951'),statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
          // 新品质量-供方自检 超期
          newPtWaitApqpOverdueCount:{resourceCode:'mkhl_xpjy_new',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('5d4bdd5cbeed83478db6dfe177f62951'),statusName:h_i18n('8556e8e115c933e48c8225ec4097f73f'),url:'',number:0},
          // 新品质量-制版设计稿 待上传
          newPtWaitPictureCount :{resourceCode:'mkhl_xmbk',resourceName: h_i18n('e9b78029dd0f622fb0179d4b47f5a8b8'),name:h_i18n('b577ca398cbf20fdf7be5e7e585dd00f'),statusName:h_i18n('7027296030d6697a53257712a23bfc50'),url:'',number:0},
          // 新品质量-制版设计稿 驳回
          newPtWaitPictureBackCount:{resourceCode:'mkhl_xmbk',resourceName: h_i18n('e9b78029dd0f622fb0179d4b47f5a8b8'),name:h_i18n('b577ca398cbf20fdf7be5e7e585dd00f'),statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
          // 测试认可-检验标准 未提交
          approvetestStandardWaitSubmit :{resourceCode:'mkhl_csrk_csnl_jybz_new',resourceName: h_i18n('4c4ed23045c9ae8de304b3c398ce7619'),name:h_i18n('ecc2661c26065854bcbf5ca8153a14cb'),statusName:h_i18n('c3ef66a0cea6beb97c22dd26d4dd1728'),url:'',number:0},
          // 测试认可-检验标准 未审核
          approvetestStandardWaitAudit :{resourceCode:'mkhl_csrk_csnl_jybz_new',resourceName: h_i18n('4c4ed23045c9ae8de304b3c398ce7619'),name:h_i18n('ecc2661c26065854bcbf5ca8153a14cb'),statusName:h_i18n('97a81dbd411fdc693cb469849557e2f7'),url:'',number:0},
          // 测试认可 未提交
          enterNo :{resourceCode:'mkhl_csrk',resourceName: h_i18n('96b190ab78a6f3c744fa3d56677e1d14'),name:h_i18n('96b190ab78a6f3c744fa3d56677e1d14'),statusName:h_i18n('c3ef66a0cea6beb97c22dd26d4dd1728'),url:'',number:0},
          // 测试认可 未审核
          auditNo :{resourceCode:'mkhl_csrk',resourceName: h_i18n('96b190ab78a6f3c744fa3d56677e1d14'),name:h_i18n('96b190ab78a6f3c744fa3d56677e1d14'),statusName:h_i18n('97a81dbd411fdc693cb469849557e2f7'),url:'',number:0},
          // 新品质量-模板 待上传
          newPtWaitTempletCount :{resourceCode:'mkhl_xmbk',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('d7a337917a4a4c2597dcfbcdcd54b96e'),statusName:h_i18n('7027296030d6697a53257712a23bfc50'),url:'',number:0},
          // 新品质量-模板 超期
          newPtWaitTempletOverdueCount :{resourceCode:'mkhl_xmbk',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('d7a337917a4a4c2597dcfbcdcd54b96e'),statusName:h_i18n('8556e8e115c933e48c8225ec4097f73f'),url:'',number:0},
          // 新品质量-模板 驳回
          newPtWaitTempletBackCount  :{resourceCode:'mkhl_xmbk',resourceName: h_i18n('802f9c15e5f598fd4d2c45424ccbebc6'),name:h_i18n('d7a337917a4a4c2597dcfbcdcd54b96e'),statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
        })),
        processQualityTodoType:computed(()=>({ // 过程质量
          // 变更管理 驳回
          changMtBh:{resourceCode:'mkhl_bggl',resourceName: h_i18n('3e1cb90cfee90167d41ab7503eba5daf'),name:h_i18n('3e1cb90cfee90167d41ab7503eba5daf'),statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
          // 出厂检验报告 待审核
          reportAuditDeal:{resourceCode:'mkhl_ccjybgNew_ccjybg',resourceName: h_i18n('515ddeee81af7132f758a3c4a18f1cef'),name:h_i18n('515ddeee81af7132f758a3c4a18f1cef'),statusName:h_i18n('5cb424765cb101866f47ca115605ce3b'),url:'',number:0},
          // 出厂报告模板 待提交
          reportModelSubmitDeal:{resourceCode:'mkhl_ccjybgNew_ccbgmb',resourceName: h_i18n('b8fd5c6d8a6e6b652403c8fd7bbc79b1'),name:h_i18n('b8fd5c6d8a6e6b652403c8fd7bbc79b1'),statusName:h_i18n('a9c09d3297b708f0ff815a93ec5f4145'),url:'',number:0},
          // 出厂报告模板 驳回
          reportModelRejectDeal:{resourceCode:'mkhl_ccjybgNew_ccbgmb',resourceName: h_i18n('b8fd5c6d8a6e6b652403c8fd7bbc79b1'),name:h_i18n('b8fd5c6d8a6e6b652403c8fd7bbc79b1'),statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
          // 交付质量判定 待关联
          planReportDgl:{resourceCode:'mkhl_ccjybgNew_jfzlpd',resourceName: h_i18n('415ae3781a9af95efc74ae1de4eb71c5'),name:h_i18n('415ae3781a9af95efc74ae1de4eb71c5'),statusName:h_i18n('0668c7fd548e4c0d84150f0617b872f2'),url:'',number:0},
          // 交付质量判定 已撤销
          planReportCx:{resourceCode:'mkhl_ccjybgNew_jfzlpd',resourceName: h_i18n('415ae3781a9af95efc74ae1de4eb71c5'),name:h_i18n('415ae3781a9af95efc74ae1de4eb71c5'),statusName:h_i18n('50239f4fee57468801a2964dfb7b687e'),url:'',number:0},
          // 交付质量判定 驳回
          planReportBh:{resourceCode:'mkhl_ccjybgNew_jfzlpd',resourceName: h_i18n('415ae3781a9af95efc74ae1de4eb71c5'),name:h_i18n('415ae3781a9af95efc74ae1de4eb71c5'),statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
          // VMI交付质量判定 待关联
          vmiPlanReportDgl:{resourceCode:'mkhl_ccjybgNew_vmijfzlpd',resourceName: h_i18n('c919da822120f25f53815a26a294cdf3'),name:h_i18n('c919da822120f25f53815a26a294cdf3'),statusName:h_i18n('0668c7fd548e4c0d84150f0617b872f2'),url:'',number:0},
          // VMI交付质量判定 已撤销
          vmiPlanReportCx:{resourceCode:'mkhl_ccjybgNew_vmijfzlpd',resourceName: h_i18n('c919da822120f25f53815a26a294cdf3'),name:h_i18n('c919da822120f25f53815a26a294cdf3'),statusName:h_i18n('50239f4fee57468801a2964dfb7b687e'),url:'',number:0},
          // VMI交付质量判定 驳回
          vmiPlanReportBh:{resourceCode:'mkhl_ccjybgNew_vmijfzlpd',resourceName: h_i18n('c919da822120f25f53815a26a294cdf3'),name:h_i18n('c919da822120f25f53815a26a294cdf3'),statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
          // 大宗商检验报告 待上传
          bulkReportWaitDeal:{resourceCode:'mkhl_dzsjybg',resourceName: h_i18n('0be0fcb5e2ef6b3333b475ae869a85c5'),name:h_i18n('0be0fcb5e2ef6b3333b475ae869a85c5'),statusName:h_i18n('7027296030d6697a53257712a23bfc50'),url:'',number:0},
          // 市场不良品 待分析
          unAnalyzeNum:{resourceCode:'mkhl_xcblp',resourceName: h_i18n('6678172a32b1b7a2d056bda472aee0fb'),name:h_i18n('6678172a32b1b7a2d056bda472aee0fb'),statusName:h_i18n('a12d192d76ca5fa6c2cbea15ebb61421'),url:'',number:0},
          // 市场不良品 待分析驳回
          marketRejectNum:{resourceCode:'mkhl_xcblp',resourceName: h_i18n('6678172a32b1b7a2d056bda472aee0fb'),name:h_i18n('6678172a32b1b7a2d056bda472aee0fb'),statusName:h_i18n('2e5e238020e90cdf7ad33788f8fd9d79'),url:'',number:0},
        })),
        userEvaluationTodoType:computed(()=>({ // 用户评价  改 质量改善
          // 市场自动 认责单总数：质量改善左侧显示 不用了
          // claimTotalCount:{resourceCode:'mkhl_zlsp_sp',resourceName: h_i18n('735d49a299ac9bc2db6056ab586633ce'),name:h_i18n('735d49a299ac9bc2db6056ab586633ce'),statusName:'',url:'',number:0, key:'claimTotalCount'},
          // 市场 自动认责单待确认数
          reClaimCount:{resourceCode:'mkhl_zlsp_sp',resourceName: h_i18n('0D84FDA7D0FDDB520B380D95E4FF4E15'),name:h_i18n('0D84FDA7D0FDDB520B380D95E4FF4E15'),statusName:h_i18n('2a2772fa8f6d68423b4656905884c5b4'),url:'',number:0,key:'reClaimCount'},
          // 纠偏单 待整改
          rectifyCount:{resourceCode:'mkhl_jbd_jbd',resourceName: h_i18n('f37dba0758deb9ad0bead5f15776dd35'),name:h_i18n('f37dba0758deb9ad0bead5f15776dd35'),statusName:h_i18n('e17445c380a7667d92f87d01d6703e42'),url:'',number:0},
          // 纠偏单 审核不通过
          rectifyApprovalRefuseCount:{resourceCode:'mkhl_jbd_jbd',resourceName: h_i18n('f37dba0758deb9ad0bead5f15776dd35'),name:h_i18n('f37dba0758deb9ad0bead5f15776dd35'),statusName:h_i18n('abad330f7fe92f41627d9a704ee5fc9e'),url:'',number:0},
          // 8D整改单 待整改
          rejects8dCount:{resourceCode:'mkhl_zg',resourceName: h_i18n('327b8141aa34a7e4294c6aba8f0d8756'),name:h_i18n('34d22f83ae2b434ad919397ed951b25e'),statusName:h_i18n('e17445c380a7667d92f87d01d6703e42'),url:'',number:0},
          // 8D整改单 驳回
          rejects8dBackCount:{resourceCode:'mkhl_zg',resourceName: h_i18n('327b8141aa34a7e4294c6aba8f0d8756'),name:h_i18n('34d22f83ae2b434ad919397ed951b25e'),statusName:h_i18n('32525478cd5c1c93de9c71246021b595'),url:'',number:0},
	  // 停检
          rejectsStopCount:{resourceCode:'mkhl_tjd',resourceName: h_i18n('0addf9d81daedc6979addd92d00e46c1'),name:h_i18n('0addf9d81daedc6979addd92d00e46c1'),statusName:h_i18n('e17445c380a7667d92f87d01d6703e42'),url:'',number:0},
          rejectsStopBackCount:{resourceCode:'mkhl_tjd',resourceName: h_i18n('0addf9d81daedc6979addd92d00e46c1'),name:h_i18n('0addf9d81daedc6979addd92d00e46c1'),statusName:h_i18n('9a7b15dccc5cda2e3db1110678576104'),url:'',number:0},
          // 用户抱怨差评 未交互
          backLogInfo:{resourceCode:'mkhl_yhpj',resourceName: h_i18n('daa0d8109abe1b8f64c2802b5bc262a1'),name:h_i18n('a92dca781ceae32533208acf6f4de3db'),statusName:h_i18n('1a88ac0ce7cda47b71f0703ade4b6d23'),url:'',number:0},
          // 大宗商质量数据 入厂不合格待确认
          batchAppealWaitDeal:{resourceCode:'mkhl_hmqm',resourceName: h_i18n('8fca15422833b617f9ff40381a3a01a5'),name:h_i18n('8fca15422833b617f9ff40381a3a01a5'),statusName:h_i18n('8e6f1fbeffda21c46b0c43df4608123c'),url:'',number:0},

          // 大宗商质量数据 入厂待上传
          batchWaitUpload:{resourceCode:'mkhl_hmqm',resourceName: h_i18n('8fca15422833b617f9ff40381a3a01a5'),name:h_i18n('8fca15422833b617f9ff40381a3a01a5'),statusName:h_i18n('cbb29a75ec5ff07065fbd8f2936deb9b'),url:'',number:0},
          // 大宗商质量数据 退次信息待确认
          spotAppealWaitDeal:{resourceCode:'mkhl_hmqm',resourceName: h_i18n('8fca15422833b617f9ff40381a3a01a5'),name:h_i18n('8fca15422833b617f9ff40381a3a01a5'),statusName:h_i18n('2cfa0c5c1ee14385a496046903ac7098'),url:'',number:0},
          // 大宗商质量数据 退次待录入
          spotWaitSubmit:{resourceCode:'mkhl_hmqm',resourceName: h_i18n('8fca15422833b617f9ff40381a3a01a5'),name:h_i18n('8fca15422833b617f9ff40381a3a01a5'),statusName:h_i18n('2679d3b89e5d3d47723502a45061fa58'),url:'',number:0},
        })),
        courseLearnTodoType:{ // 课程学习
          // studyCount:{resourceCode:'mkhl_kcxx',resourceName: '课程学习',name:'课程学习',statusName:'课程未完成',url:'https://histudy.haier.net/specialTopic/searchSpecialList',number:0},
          // testCount:{resourceCode:'mkhl_kcxx',resourceName: '课程学习',name:'课程学习',statusName:'考试未完成',url:'https://histudy.haier.net/specialTopic/searchSpecialList',number:0},
        }
      })
      onMounted(() => {
        getTreeList()
      });
      // 渲染待办显示
      const viewTodo = (i,index) => {
        let theKey = null
        if(data.toDoArray && data.toDoArray.length > 0 && Object.keys(data.toDoArray[i * 9 + index])[0]){
          theKey = Object.keys(data.toDoArray[i * 9 + index])[0]
          // console.log(i,index,data.toDoArray[i * 6 + index])
        }
        if(todoObj.value.newProductQualityTodoType[theKey]){
          return todoObj.value.newProductQualityTodoType[theKey]
        }else if(todoObj.value.userEvaluationTodoType[theKey]){
          return todoObj.value.userEvaluationTodoType[theKey]
        }else if(todoObj.value.processQualityTodoType[theKey]){
          return todoObj.value.processQualityTodoType[theKey]
        }else if(todoObj.value.courseLearnTodoType[theKey]){
          return todoObj.value.courseLearnTodoType[theKey]
        }else {
          return {}
        }
      }
      // 切换tabs
      const changeTodoTab = (activeName) => {
        nextTick(()=>{
          data.theTodoName = activeName
          if(activeName === '新品质量'){
            data.getToDototal = getToDoTotalFun(data.getData.newProductQualityMap)
            data.todoSize = toDoTotalFun(data.getToDototal)
            makeTodoType('newProductQuality')
          }else if(activeName === '过程质量'){
            data.getToDototal = getToDoTotalFun(data.getData.processQualityMap)
            data.todoSize = toDoTotalFun(data.getToDototal)
            makeTodoType('processQuality')
          }else if(activeName === '质量改善'){
            data.getToDototal = getToDoTotalFun(data.getData.userEvaluationMap)
            data.todoSize = toDoTotalFun(data.getToDototal)
            makeTodoType('userEvaluation')
          }else if(activeName === '课程学习'){
            data.getToDototal = getToDoTotalFun(data.getData.courseLearnMap)
            data.todoSize = toDoTotalFun(data.getToDototal)
            makeTodoType('courseLearn')
          }
          // console.log(data.getToDototal,data.todoSize)
        })
      }
      // 查询待办 接口
      const getToDoInfo =() =>{
        data.todoLoading = true
        emit('todoLoading', true)
        // console.log('查询待办')
        proxy.$http({
          method:'get',
          url:`/base/sqm/commisssionSupply?vCode=${props.queryData.supplyCode}&status=${props.queryData.status}&userName=${props.queryData.userName}&roleId=${props.queryData.roleCode}`,
        }).then(res=>{
          data.getData = res.data.data // 待办接口数据

          data.getToDototal = getToDoTotalFun(data.getData.newProductQualityMap)
          data.todoSize = toDoTotalFun(data.getToDototal)
          // console.log(data.getToDototal,data.todoSize,data.toDoArray)
          // 先处理所有类型的待办，确保 url 和 id 都已填充
          makeTodoType('newProductQuality')
          makeTodoType('processQuality')
          makeTodoType('userEvaluation')
          makeTodoType('courseLearn')
          let thelistObj = {...data.getData.newProductQualityMap,...data.getData.processQualityMap ,...data.getData.userEvaluationMap ,...data.getData.courseLearnMap}
          watch(()=>todoObj.value,()=>{
            postTodoList(thelistObj)
          },{
            deep:true,
            immediate:true
          })
        }).catch(err=>{
          emit('getTodoList',[])
        }).finally(()=>{
          data.todoLoading = false
          emit('todoLoading', false)
        })
      }
      // 传给父
      const postTodoList = (thelistObj) => {
        let myTodoList = []
        for (const key in thelistObj) {
          if(thelistObj[key] !== 0){
            myTodoList.push({key:key,number:thelistObj[key]})
          }
        }
        // console.log('myTodoListmyTodoListmyTodoListmyTodoList',myTodoList)
        // todoObj.value 1维
        let todoObjTemp = {}
        for (const key in todoObj.value) {
          for (const gen in todoObj.value[key]) {
            todoObjTemp[gen]=todoObj.value[key][gen]
          }
        }

        let emitList = []
        // 右侧待办 排除项目
        let excludeList = []
        // 右侧待办 排除 claimTotalCount 市场自动认责单有*条
        // excludeList.push('claimTotalCount')
        for (const theKey in todoObjTemp) {
          myTodoList.find(item=>{
            // if(item.key === theKey && !theKey.includes(excludeList)){
            if(item.key === theKey){
              let objOfother = {key:item.key ,number:item.number , name:todoObjTemp[theKey].name, statusName:todoObjTemp[theKey].statusName}
              objOfother = {...objOfother , ...getResourceIdAndUrl({resourceCode:todoObjTemp[theKey].resourceCode ,resourceName:todoObjTemp[theKey].resourceName})}
              // objOfother.key = item.key
              // objOfother.number = item.number
              // objOfother.name = todoObjTemp[theKey].name
              // objOfother.statusName = todoObjTemp[theKey].statusName
              // console.log(objOfother)
              emitList.push(objOfother)
            }else{
              return undefined
            }
          })
        }
        emit('getTodoList',emitList)

      }
      // makeTodoType
      const makeTodoType = (type) => {
        for (const key1 in data.getData[type+'Map']) {
          if(todoObj.value[type+'TodoType'][key1]){
            let tempObject = todoObj.value[type+'TodoType'][key1]
            tempObject = {...tempObject , ...getResourceIdAndUrl({resourceCode:tempObject.resourceCode ,resourceName:tempObject.resourceName}) , number:data.getData[type+'Map'][key1]}
            todoObj.value[type+'TodoType'][key1] = tempObject
          }
          // for (const key2 in todoObj.value[type+'TodoType']) {
          //   if(key2 === key1){
          //     let tempObject = todoObj.value[type+'TodoType'][key2]
          //     tempObject = {...tempObject , ...getResourceIdAndUrl({resourceCode:tempObject.resourceCode ,resourceName:tempObject.resourceName}) , number:data.getData[type+'Map'][key1]}
          //     todoObj.value[type+'TodoType'][key2] = tempObject
          //     // console.log('tempObjecttempObject,',tempObject)
          //     console.log('todoObjtodoObjtodoObjtodoObj,',todoObj.value)
          //   }
          // }
        }
      }
      // 每一个待办类别的入口数 keylist的长度
      const getToDoTotalFun = (obj) => {
        let keyNum = 0
        data.toDoArray = []
        // 待办模块排除项
        let excludeList = []
        // 待办模块排除 reClaimCount 市场自动认责单有*条待确认
        // excludeList.push('reClaimCont')
        for (const key in obj) {
          // if(obj[key] && !key.includes(excludeList)){ 
          if(obj[key]){ 
            keyNum ++
            data.toDoArray.push({[key]:obj[key]})
          }
        }
        return keyNum
      }

      // 获取饼图图例及值
      const getPieLegendData = () => {
        // data.theTodoList=[
        //   {value:10,name:'待提交'},
        //   {value:3,name:'驳回'},
        //   {value:2,name:'超期'},
        // ]
        init()
      }
      // 计算循环数
      const toDoTotalFun = (num) => {
        return num%9 === 0 ? num/9 : Math.ceil(num/9)
      }
      // 跳转页面
      const navigateTo = (i,index) => {
        let obj = viewTodo(i,index)
        // 防护：数据未就绪时不跳转
        if (!obj || !obj.url || !obj.id) {
          console.warn('待办跳转数据未就绪:', obj)
          return
        }
        // console.log('待办obj-------->',obj)
        data.publicParams =   '&roleCode=' + props.queryData.roleCode + '&vCode=' + props.queryData.supplyCode + '&supplyCode=' + props.queryData.supplyCode + '&roleId=' + props.queryData.roleId + '&name=' + props.queryData.supplyCode + '&nickName=' + props.queryData.tempTrueName + '&trueName=' + props.queryData.tempTrueName + '&supplyName=' + props.queryData.tempSupplyName + '&userName=' + props.queryData.tempUserName + '&isSupply=' + props.queryData.isSupply + '&dataFrom=sqm'
        // 调用父级 router,routerName,resourceId
        // 其实id就行，为了保险，加个判断
        let urlId = null
        if(obj.id > obj.parentId && obj.parentId != 1){
          urlId = obj.parentId
        }else if(obj.parentId > obj.id && obj.id != 1){
          urlId = obj.id
        }else if(obj.parentId === obj.id && obj.id != 1){
          urlId = obj.id
        }else if(obj.parentId === 1) {
          urlId = obj.id
        }else{
          console.log('未查询到ID----->',obj)
        }
        emit('changeRouter',{url:obj.url ,name:obj.name, id:urlId})
        // if(obj.url){
        //   // 跳转页面
        //   // proxy.$router.push({path: obj.url, query: {...props.queryData}})
        //   window.open('http://sqm-test.qd-huangdao-test.haier.net'+obj.url+"?resourceId=" + obj.id + data.publicParams)
        // }else if(obj.getUrl){
        //   window.open('http://sqm-test.qd-huangdao-test.haier.net'+obj.getUrl+"resourceId=" + obj.id + data.publicParams)
        // }
      }
      // 计算 getResourceId 逻辑：URL 使用当前页面，resourceId 优先使用二级菜单
      const getResourceIdAndUrl = (resourceObj) => {
        const matchedResource = data.dataList.find(item => {
          return item.resourceCode === resourceObj.resourceCode && item.url
        })
        if (!matchedResource) {
          return {}
        }

        // 避免在解析待办时覆盖扁平菜单中叶子节点原始 id。
        const resourceIdUrlTemp = { ...matchedResource }
        if (String(resourceIdUrlTemp.parentId) === '1') {
          resourceIdUrlTemp.getUrl = resourceIdUrlTemp.url
          return resourceIdUrlTemp
        }

        // 兼容菜单接口将 id / parentId 返回为不同基本类型的情况。
        const parentMenu = data.dataList.find(item => {
          return String(item?.id) === String(resourceIdUrlTemp.parentId)
        })
        if (parentMenu) {
          const parentResourceId = String(parentMenu.parentId) !== '1'
            ? parentMenu.parentId
            : parentMenu.id
          // 父节点缺少标识时仍使用已命中的叶子节点 id。
          resourceIdUrlTemp.id = parentResourceId ?? resourceIdUrlTemp.id
        }

        return resourceIdUrlTemp
      }
      // 获取三级菜单
      const getTreeList = () => {
        proxy.$http({
          method: 'POST',
          url: "/base/resource/getResourceTreeByAppCode",
          data: {
            appCode: 'SQM',
            fixConfig: true,
          }
        }).then(res => {
          if (res) {
            data.treeData = res.data.data
            generateList(data.treeData)
            getToDoInfo()
          }
        })
      }
      // 展开数组
      const generateList = item => {
        for (let i = 0; i < item.length; i++) {
          const node = item[i];
          if (node.resourceTypeCode === 'MENU') {
            data.dataList.push({
              id: node.id,
              resourceName: node.resourceName,
              resourceCode: node.resourceCode,
              parentId: node.parentId,
              url: node.url,
              childFlag: node.child ? true : false
            });
          }
          if (node.child) {
            generateList(node.child);
          }
        }
      };
      const init = ()=>{
      let myChart = echarts.init(document.getElementById('theCharts'))
      var  option = {
        title: {
          text: data.theTodoName + h_i18n('b60ec8b0690bd9c0caeaa65ee80a6e01'),
          left: 'center'
        },
        graphic:{
                type:"text",
                left:"center",
                top:"50%",
                style:{
                    text:h_i18n('8ee2edef2c6b22d697fbb6846719c259'),
                    textAlign:"center",
                    fill:"#333",
                    fontSize:9,
                }
            },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'horizontal',
          x: 'center',
          y: 'bottom'
        },
        series: [
          {
            name: h_i18n('b60ec8b0690bd9c0caeaa65ee80a6e01'),
            type: 'pie',
            radius: '50%',
            data: data.theTodoList,
            itemStyle: {
              normal:{
                  label:{
                          how: true,
                          formatter: h_i18n('9492d64d0d71c8add4b96b11776270e8')
                  },
                  labelLine :{show:true}
                  }
            },
            label: {
              overflow: "break"
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      option && myChart.setOption(option)
      window.onresize = myChart.resize
      }
      return {
        ...toRefs(data),
        navigateTo,
        changeTodoTab,
        viewTodo,
        getTreeList,
        h_i18n
      };
    },
  });


</script>

<style lang="scss">
  .workbench_card_todo_style{
    width: 100%;
    height: calc(100% - 100px);
    display: flex;
    flex-direction: row;
    .workbench_card_todo_left_style{
      width: 100%;
      height: 100%;
    }
    // .workbench_card_todo_mid_style{
    //   margin: auto 0;
    //   height: 80%;
    //   width: 1px;
    //   border-left: 1px solid #E5E6EB;
    // }
    // .workbench_card_todo_right_style{
    //   width: 33%;
    //   height: 100%;
    // }
    .workbench_left_carousel_style{
      width: 1050px;
      height: 230px;
      margin: auto;
      .el-carousel__container{
        height: 220px;
      }
      .noTodo_style{
        width: 100%;
        height: 100%;
        text-align: center;
        // position: absolute;
        // top: 40%;
        margin-top: 35px;
        font-size: 14px;
        .nodata-style{
          width:100%;
          font-size: 14px;
          color:#86909c;
          height: 30px;
          line-height: 30px;
          text-align: center;
          margin-bottom: 16px;
        }
      }
      .carousel_page_style{
        width: 950px;
        height: 230px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        padding-left: 50px;
      }
      .carousel_child_style{
        width: 300px;
        height: 56px;
        img{
          object-fit: cover;
          width: 100%;
        }
        .carousel_child_text_style{
          width: 100%;
          height: 100%;
          position: relative;
          background: url('../../assets/images/todo.png') no-repeat center;
          background-size: 100% 100%;
          color: #1D2129;
          cursor: pointer;
          div{
            width: 90%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            font-size: 14px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .carousel_child_text_style:hover{
          background-color: #269af380;
          border-radius: 10px;
          div{
            white-space: normal;
          }
        }
      }
    }
  }
</style>